import React from 'react';
import {Banners} from 'features/banners';
import {OrdersTable} from 'features/orders';
import {ProfileAlertsBanner} from 'features/profile';
import {PageTitle} from 'ui';

export function OrdersPage(): React.ReactElement {
	return (
		<div className="flex flex-col max-sm:gap-5 max-sm:overflow-x-clip max-sm:pb-[max(1rem,env(safe-area-inset-bottom))]">
			<PageTitle className="mb-8 max-sm:mb-0 max-sm:text-[26px] max-sm:leading-snug">
				Мои заказы
			</PageTitle>
			<Banners className="mb-8 max-sm:mb-0" />
			<ProfileAlertsBanner className="mb-8 max-sm:mb-0" />
			<OrdersTable />
		</div>
	);
}
